import { useTranslation } from "react-i18next";
import { useCurrentWorkspace } from "~/api/queries";
import { ABILITY } from "~/api/types";
import { GitConnectionsPanel } from "~/features/git/GitConnectionsPanel";

/**
 * Settings › Integrations › Git repositories: every connection in the workspace — the
 * workspace's own and each project's — with the verbs. A project's row menu offers the same
 * panel scoped to itself.
 */
export function GitRepositories() {
  const { t } = useTranslation();
  const { data: workspace } = useCurrentWorkspace();
  const canManage = workspace?.abilities[ABILITY.workspaceUpdate] === true;

  return (
    <div className="flex flex-col gap-4">
      <p className="max-w-[76ch] text-small text-text-secondary">
        {t(
          "A repository connected here shows its structure in the sidebar and banks its history for the knowledge theatre. Connect it to the whole workspace, or to one project from that project's menu.",
        )}
      </p>
      <GitConnectionsPanel canManage={canManage} />
    </div>
  );
}
